import type { IconProps } from './types';

export const CheckIcon: React.FC<IconProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.61478 17.3269L4.78178 12.4894C4.64436 12.3492 4.56738 12.1607 4.56738 11.9644C4.56738 11.7681 4.64436 11.5796 4.78178 11.4394L5.83178 10.3894C5.97197 10.252 6.16046 10.175 6.35678 10.175C6.55309 10.175 6.74158 10.252 6.88178 10.3894L10.1413 13.6474L17.1148 6.6724C17.255 6.53498 17.4435 6.45801 17.6398 6.45801C17.8361 6.45801 18.0246 6.53498 18.1648 6.6724L19.2148 7.7224C19.3522 7.8626 19.4292 8.05109 19.4292 8.2474C19.4292 8.44371 19.3522 8.6322 19.2148 8.7724L10.6648 17.3224C10.5252 17.4604 10.337 17.5382 10.1407 17.539C9.94438 17.5399 9.75556 17.4637 9.61478 17.3269Z"
                fill="currentColor"
            />
        </svg>
    );
};
